<template>
  <div>
    <logged-in-header />
    <vending-categories-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import vendingCategoriesPanel from "../components/vending-category/VendingCategoriesPanel";

export default {
  components: {
    loggedInHeader,
    vendingCategoriesPanel
  }
};
</script>
